export default function NotFound() {
    return (
        <main style={{ padding: "1rem" }}>
            <p>Page not found</p>
        </main>
    );
}